import { ALERT_TILE_ID } from "../getFeatures";
import { DataType } from "../../types/lib/types";
import { fiwareDataItemType } from "../../types";
import { MapGeoJSONFeature } from "maplibre-gl";


/* ***************** 
 * featureのフィルタリング処理
 * *****************/ 
export const filterdFeatures = (
    features: MapGeoJSONFeature[], 
    menuItems: DataType[] | undefined
): MapGeoJSONFeature[] | undefined => {

    return features.filter((feature) =>
        (
            menuItems?.find((catalog) => 
                    (catalog.dataType === "fiware" && 
                    (catalog as unknown as fiwareDataItemType).dataId === feature.source
                ) || 
                catalog.tileId === feature.source
            ) ||
            feature.source === ALERT_TILE_ID || 
            feature.source === 'osm'
        )
    );
}
